import { createFileRoute } from '@tanstack/react-router';
import { DirectoryListBody } from '@/components/directory/DirectoryListBody';

// Divisible by every grid width (3-col desktop, 2-col tablet, 1-col
// mobile) so each loaded page keeps the card rows complete — 25 left a
// lone card on the last row after every "Load more".
const DIRECTORY_PAGE_SIZE = 24;

type DirectorySearch = {
  q?: string;
  sort?: 'recommended' | 'recent' | 'name';
  scope?: 'all' | 'circle' | 'network';
  networkId?: string;
  city?: string;
  loc?: string[];
  net?: string[];
  topic?: string[];
  industry?: string[];
  career?: string[];
  openTo?: string[];
  community?: string[];
};

function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}
function pickStrArr(v: unknown): string[] | undefined {
  if (Array.isArray(v)) return v.filter((s) => typeof s === 'string') as string[];
  if (typeof v === 'string' && v.length > 0) return [v];
  return undefined;
}

export const Route = createFileRoute('/_authed/directory/')({
  validateSearch: (raw: Record<string, unknown>): DirectorySearch => {
    const sort =
      raw.sort === 'name' || raw.sort === 'recent' || raw.sort === 'recommended' ? raw.sort : undefined;
    const scope =
      raw.scope === 'all' || raw.scope === 'circle' || raw.scope === 'network'
        ? raw.scope
        : undefined;
    return {
      ...(pickStr(raw.q) ? { q: pickStr(raw.q) as string } : {}),
      ...(sort !== undefined ? { sort } : {}),
      ...(scope !== undefined ? { scope } : {}),
      ...(pickStr(raw.networkId) ? { networkId: pickStr(raw.networkId) as string } : {}),
      ...(pickStr(raw.city) ? { city: pickStr(raw.city) as string } : {}),
      ...(pickStrArr(raw.loc) ? { loc: pickStrArr(raw.loc) as string[] } : {}),
      ...(pickStrArr(raw.net) ? { net: pickStrArr(raw.net) as string[] } : {}),
      ...(pickStrArr(raw.topic) ? { topic: pickStrArr(raw.topic) as string[] } : {}),
      ...(pickStrArr(raw.industry) ? { industry: pickStrArr(raw.industry) as string[] } : {}),
      ...(pickStrArr(raw.career) ? { career: pickStrArr(raw.career) as string[] } : {}),
      ...(pickStrArr(raw.openTo) ? { openTo: pickStrArr(raw.openTo) as string[] } : {}),
      ...(pickStrArr(raw.community) ? { community: pickStrArr(raw.community) as string[] } : {}),
    };
  },
  component: DirectoryPage,
});

function DirectoryPage() {
  return <DirectoryListBody pageSize={DIRECTORY_PAGE_SIZE} />;
}
